<!--
* 组件名 : 悬浮MINI音频播放器
* 开发者 : HN
*
* 参数:
*  audio    { Object }   required - 音频信息
*  autoplay { Boolean }           - 播放器渲染后是否自动播放音频
*
* 事件:  null
* 
*
-->

<template>
  <section class="v-fixed-player">
    <!-- mini音频播放器 -->
    <div class="mini-player" ref="miniPlayerWrap">
      <v-btn class="play-and-pause" @btnClick="on_play_pause_click">
        <v-icon v-if="!isPause">pause</v-icon>
        <v-icon v-else>play_arrow</v-icon>
      </v-btn>
      <div class="control-box" ref="miniControlBox">
        <div class="player-title">
          <h4 :class="{ marquee: isMarquee }" ref="playTitle">
            {{ audio.lists[0].title }}
          </h4>
        </div>

        <div class="process-bar-box">
          <div class="process-target" ref="mpProcessBar" />
          <span class="current" ref="mpCurrentTime">
            {{ audio.lists[0].duration }}
          </span>
        </div>
      </div>
      <v-btn class="lyrics-btn" @btnClick="on_lyrics_btn_click">
        <img
          src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMy4wMDEiIGhlaWdodD0iMTYuMDAzIiB2aWV3Qm94PSIwIDAgMTMuMDAxIDE2LjAwMyI+DQogIDxwYXRoIGlkPSJMUkMiIGQ9Ik02MTcyLDE0NTQ3LjU2NmExLDEsMCwwLDEtMS0xdi0xNGExLDEsMCwwLDEsMS0xaDh2M2ExLDEsMCwwLDAsMSwxaDN2MTFhMSwxLDAsMCwxLTEsMVptNi4zOTMtMy43MjlhMS41MzcsMS41MzcsMCwwLDAsMy4wNzQtLjA0bDAtMy45MjVoLjg4N3YtMS4wMjFINjE4MC40djMuNWExLjcxMywxLjcxMywwLDAsMC0uNS0uMDg4aC0uMDI2QTEuNTM2LDEuNTM2LDAsMCwwLDYxNzguMzksMTQ1NDMuODM4Wm0tNS4zOTMtLjcwOGg0di0xaC00Wm0wLTIuNzgyaDZ2LTFoLTZabTAtMi43NzhoNnYtMWgtNlptOC41MzItMi42NjFhLjkuOSwwLDAsMS0uODc2LS45Mjh2LTIuNDE3bDAsMCwzLjE1MSwzLjM0MVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02MTcwLjk5NiAtMTQ1MzEuNTYzKSIgZmlsbD0iI2ZmZiIvPg0KPC9zdmc+DQo="
        />
        <span>LRC</span>
        <div class="hint">{{ $TL.enjoyhintLyric }}</div>
      </v-btn>
    </div>
    <!-- 侧滑悬浮播放器 -->
    <div class="lyrics-player" ref="lyricsPlayerWrap">
      <div class="lyrics-player-bg" ref="lyricsPlayerBg"></div>
      <v-btn class="close-btn" :linear="true" @btnClick="on_close_btn_click">
        <v-icon>close</v-icon>
      </v-btn>
      <div class="lyrics-box nano" ref="lyricsBox">
        <div class="nano-content">
          <v-spinner v-if="this.isLyricsAnimateLoading" />
          <ul
            v-show="!this.isLyricsAnimateLoading"
            class="lyric-box"
            ref="lyricBox"
          ></ul>
        </div>
      </div>
      <div class="control-box">
        <v-btn
          class="play-and-pause"
          :control-style="true"
          @btnClick="on_play_pause_click"
        >
          <v-icon v-if="!isPause">pause</v-icon>
          <v-icon v-else>play_arrow</v-icon>
        </v-btn>
        <div class="process-box">
          <div class="process-bar-box">
            <span class="current" ref="lpCurrentTime">00:00</span>
            <div class="process-target" ref="lpProcessBar"></div>
            <span class="duration" ref="duration">
              {{ audio.lists[0].duration }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import Range from "@/vendor/range.min";
import vAudio from "@/vendor/v-audio.min";
import Lyrics from "@/vendor/lyrics.min";
import { replace_from } from "@/framework/components/VFullScreenSongsPlayer/components/lyrics/utils";
import { uuidv4, get_text_outer_width } from "utils/util";

export default {
  name: "fixed-player",
  props: {
    audio: {
      type: Object,
      required: true,
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("global", ["apiUri"]),
  },
  data() {
    this.audioRange = null;
    this.audioRangeLyrics = null;
    this.VAudioObject = null;
    this.isTap = false;
    this.prevIndex = 0;
    this.L = null;
    this.playerId = uuidv4();
    return {
      isPause: true,
      isLyricsAnimateLoading: true,
      isMarquee: false,
    };
  },

  mounted() {
    //  若是没有列表标题, 则认为无需显示这首歌
    if (this.audio.title.length === 0) {
      $(this.$refs.miniPlayerWrap).remove();
      return;
    }

    this.init_audio();
    this.init_player_title();
    this.$P.$on("pause-all-audio", this.pause);
  },

  beforeDestroy() {
    this.VAudioObject?.destroy?.();
    this.audioRange?.destroy?.();
    this.audioRangeLyrics?.destroy?.();
    this.L?.destroy?.();
    this.$P.$off("pause-all-audio", this.pause);
  },
  methods: {
    pause(playerId) {
      if (playerId === this.playerId) return;
      this.VAudioObject?.pause?.();
    },
    init_audio() {
      this.VAudioObject = new vAudio({
        src: this.audio.lists[0].audioUri,
        autoPlay: this.autoplay,
      });
      this.range_init();
      this.init_lyrics();
      this.event_handler();
    },
    init_lyrics() {
      // $(this.$refs.lyricsBox).nanoScroller();

      this.L = new Lyrics({
        el: this.$refs.lyricBox,
        detectFrom: replace_from,
        fixBreakLine: true,
        lrcLoadTimeout: 15000,
      });

      this.load_lyrics(this.audio.lists[0].lrcUri);

      this.L.on("lrcLoaded", () => {
        setTimeout(() => {
          $(this.$refs.lyricBox).html(
            this.$P.uni2zg($(this.$refs.lyricBox).html())
          );
        }, 600);
      });
    },
    load_lyrics(lrc) {
      this.isLyricsAnimateLoading = true;
      // $(this.$refs.lyricsBox).nanoScroller({ scrollTop: 0 });
      this.L.load_promise(
        (process.env.NODE_ENV === "development"
          ? `http://localhost:8888/`
          : "") + this.get_lrc_remote_link(lrc)
      ).then(() => {
        this.isLyricsAnimateLoading = false;
      });
    },
    get_lrc_remote_link(lrcPath) {
      return (
        this.apiUri +
        `?${$.param({
          lrc: lrcPath,
          action: "gp_home_ajax",
          page_name: "page-hymns",
          page_method: "getLrc",
        })}`
      );
    },
    range_init() {
      this.audioRange = new Range({
        el: this.$refs.mpProcessBar,
        min: 0,
        max: 1000,
        step: 1,
        value: 0,
      });
      this.audioRangeLyrics = new Range({
        el: this.$refs.lpProcessBar,
        min: 0,
        max: 1000,
        step: 1,
        value: 0,
      });
    },
    event_handler() {
      this.audio_event_handle();
      this.audio_range_event_handle();
    },
    audio_range_event_handle() {
      let newPercentage = 0;
      this.audioRange
        .on("slideChange", (event, value, percentage, isManually) => {
          let currentTime = this.VAudioObject.get_duration()
            ? this.VAudioObject.get_duration() * percentage
            : 0;
          this.update_current_time(currentTime);
          if (isManually) return;

          //  拖拽时触发
          newPercentage = percentage;
        })
        .on("changeStart", (event) => {
          this.isTap = true;
        })
        .on("changeEnded", (event) => {
          this.isTap = false;
          this.VAudioObject.set_current_time(newPercentage, true);
          !this.VAudioObject.audio.paused && this.VAudioObject.play();
        });

      this.audioRangeLyrics
        .on("slideChange", (event, value, percentage, isManually) => {
          let currentTime = this.VAudioObject.get_duration()
            ? this.VAudioObject.get_duration() * percentage
            : 0;
          this.update_current_time(currentTime);
          if (isManually) return;

          //  拖拽时触发
          newPercentage = percentage;
        })
        .on("changeStart", (event) => {
          this.isTap = true;
        })
        .on("changeEnded", (event) => {
          this.isTap = false;
          this.VAudioObject.set_current_time(newPercentage, true);
          !this.VAudioObject.audio.paused && this.VAudioObject.play();
        });
    },
    audio_event_handle() {
      this.VAudioObject.on("loaded", (event, currentTime, duration) => {
        this.VAudioObject.pause();
      })
        .on("pause", () => {
          this.isPause = true;
        })
        .on("ended", () => {
          this.VAudioObject.set_current_time(0);
          this.VAudioObject.play();
          setTimeout(() => {
            this.VAudioObject.pause();
          }, 400);
        })
        .on("play", () => {
          this.$P.$emit("pause-all-audio", this.playerId);
          this.isPause = false;
        })
        .on(
          "watcherUpdate",
          (event, currentTime, percentage, duration, ended) => {
            this.on_watcher_update_handle(
              currentTime,
              percentage,
              duration,
              ended
            );
          }
        );
    },
    update_current_time(time) {
      this.$refs.mpCurrentTime.innerHTML = this.VAudioObject.format_time(time);
      this.$refs.lpCurrentTime.innerHTML = this.VAudioObject.format_time(time);

      // bug safari 不知为何原因 无法及时渲染dom更新
      $([this.$refs.mpCurrentTime, this.$refs.lpCurrentTime]).css(
        "opacity",
        0.99 + Math.random() / 100
      );
    },
    on_watcher_update_handle(currentTime, percentage, duration, ended) {
      if (this.isTap) return;
      this.audioRange.set_value(percentage, true);
      this.audioRangeLyrics.set_value(percentage, true);
      this.update_current_time(currentTime);
      this.lyrics_scroll(currentTime, false, true);
    },
    lyrics_scroll(currentTime, isForce = false, isBasicScroll = false) {
      let currentLrcObj = this.L.check(currentTime);
      if (currentLrcObj) {
        if (isForce || this.prevIndex != currentLrcObj.index) {
          this.scroll_animate(currentLrcObj.index, isBasicScroll);
          this.prevIndex = currentLrcObj.index;
        }
      }
    },
    scroll_animate(index, isBasicScroll) {
      let $lrcItems = $(this.$refs.lyricBox).find("li");

      if ($lrcItems.length > 0) {
        let $nowItem = $lrcItems.eq(index);
        if ($nowItem.length === 0) return;
        $nowItem.addClass("on").siblings().removeClass("on");

        let parent = $(this.$refs.lyricBox).parent();
        let parentHeight = parent.outerHeight();
        let half = parentHeight / 2;
        let height = $nowItem.outerHeight();

        $nowItem.velocity("scroll", {
          container: parent,
          duration: isBasicScroll ? 450 : 0,
          easing: "easeInOutQuad",
          offset: ((height + half) / 2 + height) * -1,
          delay: 0,
        });
      }
    },
    on_play_pause_click() {
      this.VAudioObject?.toggle_play?.();
    },

    /**
     * 初始化MINI播放器的标题是否显示轮播效果
     */
    init_player_title() {
      let playTitleWidth = get_text_outer_width(
        $(this.$refs.playTitle).text().trim()
      );

      let miniControlBoxWidth = $(this.$refs.miniControlBox).find('.player-title').outerWidth()
      if (playTitleWidth >= miniControlBoxWidth) {
        this.isMarquee = true;
      }
    },

    /**
     * 当mini播放器的歌词显示按钮被点击时
     */
    on_lyrics_btn_click() {
      let self = this;
      $(".hint").hide();

      this.$emit("showLyricsPlayer");
      $(this.$refs.lyricsPlayerWrap).css("pointer-events", "");

      $(this.$refs.miniPlayerWrap).velocity(
        { opacity: 0, translateX: this.$P.isRtl ? 200 : -200, translateZ: 0 },
        {
          easing: "easeInOutCubic",
          duration: 420,
          complete: () => {
            $(this.$refs.lyricsPlayerWrap).velocity(
              this.$P.isRtl
                ? "transition.slideRightBigIn"
                : "transition.slideLeftBigIn",
              {
                easing: "cubic-bezier(.12,.81,.91,.3)",
                duration: 370,
                complete() {
                  // $(self.$refs.lyricsBox).nanoScroller();
                },
              }
            );
          },
        }
      );
    },
    on_close_btn_click() {
      this.$emit("showMiniPlayer");
      $(this.$refs.lyricsPlayerWrap).css("pointer-events", "none");
      $(this.$refs.lyricsPlayerWrap).velocity(
        { opacity: 0, translateX: this.$P.isRtl ? 200 : -200, translateZ: 0 },
        {
          easing: "easeInOutCubic",
          duration: 420,
          complete: () => {
            $(this.$refs.miniPlayerWrap).velocity(
              this.$P.isRtl
                ? "transition.slideRightBigIn"
                : "transition.slideLeftBigIn",
              $.extend(
                { display: "flex" },
                {
                  easing: "cubic-bezier(.12,.81,.91,.3)",
                  duration: 420,
                }
              )
            );
          },
        }
      );
    },
  },
};
</script>

<style lang="scss">
@import "./index";
</style>
